import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

import Home from '../Home';
import ArchitectureOverview from '../ArchitectureOverview';
import Downloads from '../Downloads';
import DownloadsDrafts from '../DownloadsDrafts';
import Infographics from '../Infographics';
import WhitepapersPage from '../WhitepapersPage';
import NotFound from '../NotFound';
import MailingPage from '../MailingPage';
import Ecosystem from '../Ecosystem';
import Skyminer from '../Skyminer';
import Skywire from '../Skywire';
import SkywireLanding from '../SkywireLanding';
import SkywalletLanding from '../SkywalletLanding';
import SkyminerLanding from '../SkyminerLanding';
import SkycoinLanding from '../SkycoinLanding';
import MobileWalletsLanding from '../MobileWalletsLanding';
import CXO from '../CXO';
import CX from '../CXs';
import CXIndex from '../CXs/components/CxIndex';
import CXDocs from '../CXs/components/CxDocs';
import CXExample from '../CXs/components/CxExample';
import CXAbout from '../CXs/components/CxAbout';
import CXChains from '../CXs/components/CxChains';
import CXInstallation from '../CXs/components/CxInstallation';
import CXLanding from '../CXLanding';
import Fiber from '../Fiber';
import WhiteListRedirect from '../Whitelist/WhiteListRedirect';
import WhitelistForm from '../WhitelistForm';
import SkyminerForm from '../SkyminerForm';
import Obelisk from '../Obelisk';
import GalleryPage from '../GalleryPage';
import ThankYouPage from '../ThankYouPage';
import NYCMeetUpLanding from '../NYCMeetUpLanding';
import QRCode from '../QRCode';
import PressReleases from '../PressReleases';
import Release20190320 from '../PressReleases/Release';
import Release20190823 from '../PressReleases/ReleasePart';
import Release20191014 from '../PressReleases/ReleaseOctober';
import Release20191018 from '../PressReleases/Release20191018';
import Release20191126 from '../PressReleases/Release20191126';
import Skywallet from '../Skywallet';
import SkywalletHDK from '../SkywalletHDK';
import Jobs from '../JobsPage';
import Terms from '../Terms';
import CookiesTerms from '../CookiesTerms';

const Routes = ({ match }) => {
  const prefix = match.path === '/' ? '/' : '/:locale/';
  return (
    <Switch>
      <Route path={`${prefix}`} exact component={Home} />
      <Route path={`${prefix}downloads`} exact component={Downloads} />
      <Route path={`${prefix}terms`} exact component={Terms} />
      <Route path={`${prefix}legal`} exact component={CookiesTerms} />
      <Route path={`${prefix}downloads-drafts`} exact component={DownloadsDrafts} />
      <Route path={`${prefix}whitepapers`} component={WhitepapersPage} />
      <Route path={`${prefix}infographics`} exact component={Infographics} />
      <Route path={`${prefix}architecture-overview`} exact component={ArchitectureOverview} />
      <Redirect strict from={`${prefix}roadmap`} to={`${prefix}`} />
      <Route path={`${prefix}mailing-list`} exact component={MailingPage} />
      <Redirect strict from={`${prefix}buy`} to={`${prefix}`} />
      <Route path={`${prefix}ecosystem`} exact component={Ecosystem} />
      <Route path={`${prefix}skyminer`} exact component={Skyminer} />
      <Route path={`${prefix}skywire`} exact component={Skywire} />
      <Route path={`${prefix}landing/skywire`} exact component={SkywireLanding} />
      <Route path={`${prefix}landing/mobile-wallets`} exact component={MobileWalletsLanding} />
      <Route path={`${prefix}landing/cx`} exact component={CXLanding} />
      <Route path={`${prefix}landing/skywallet`} exact component={SkywalletLanding} />
      <Route path={`${prefix}landing/skyminer`} exact component={SkyminerLanding} />
      <Route path={`${prefix}landing/skycoin`} exact component={SkycoinLanding} />
      <Route path={`${prefix}landing/nyc-meetup`} exact component={NYCMeetUpLanding} />
      <Route path={`${prefix}cxo`} exact component={CXO} />
      <Route path={`${prefix}cx`} exact component={CX} />
      <Route path={`${prefix}cx/home`} exact component={CXIndex} />
      <Route path={`${prefix}cx/docs`} exact component={CXDocs} />
      <Route path={`${prefix}cx/example`} exact component={CXExample} />
      <Route path={`${prefix}cx/about`} exact component={CXAbout} />
      <Route path={`${prefix}cx/chains`} exact component={CXChains} />
      <Route path={`${prefix}cx/installation`} exact component={CXInstallation} />
      <Route path={`${prefix}cx-chains`} exact component={CXChains} />
      <Route path={`${prefix}fiber`} exact component={Fiber} />
      <Route path={`${prefix}whiteList`} exact component={WhiteListRedirect} />
      <Route path={`${prefix}orderskyminer`} exact component={SkyminerForm} />
      <Route path={`${prefix}whiteListForm`} exact component={WhitelistForm} />
      <Route path={`${prefix}obelisk`} exact component={Obelisk} />
      <Route path={`${prefix}qrcode`} exact component={QRCode} />
      <Route path={`${prefix}gallery`} exact component={GalleryPage} />
      <Route path={`${prefix}thankyou`} exact component={ThankYouPage} />
      <Route path={`${prefix}pressreleases`} exact component={PressReleases} />
      <Route path={`${prefix}pressreleases/release-2019-03-20`} exact component={Release20190320} />
      <Route path={`${prefix}pressreleases/release-2019-08-23`} exact component={Release20190823} />
      <Route path={`${prefix}pressreleases/release-2019-10-14`} exact component={Release20191014} />
      <Route path={`${prefix}pressreleases/release-2019-10-18`} exact component={Release20191018} />
      <Route path={`${prefix}pressreleases/release-2019-11-26`} exact component={Release20191126} />
      <Route path={`${prefix}jobs`} exact component={Jobs} />
      <Route path={`${prefix}skywallet`} exact component={Skywallet} />
      <Redirect strict from="/skywallethdk" to="/skywallet-hdk" />
      <Route path={`${prefix}skywallet-hdk`} exact component={SkywalletHDK} />
      <Redirect from={`${prefix}whitepapers.html`} to={`${prefix}whitepapers`} />
      <Redirect from={`${prefix}infographics.html`} to={`${prefix}infographics`} />
      <Redirect from={`${prefix}downloads.html`} to={`${prefix}downloads`} />
      <Redirect from={`${prefix}faq.html`} to={`${prefix}`} />
      <Redirect from={`${prefix}index.html`} to={`${prefix}`} />
      <Redirect from={`${prefix}skyminerform`} to={`${prefix}orderskyminer`} />
      <Route path={`${prefix}*`} component={NotFound} />
    </Switch>
  );
};

Routes.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.js